import React from 'react';
import { Flex, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import colors from '../../../../styles/theme/foundation/colors';

function RowGridColumn({ label, align, children, justify, ...childProps }) {
  return (
    <Flex alignItems={align} direction="column" height="100%" justify={justify} width="100%">
      <Text
        alignItems="flex-start"
        color={colors.greyScale['700']}
        mb={1}
        position="relative"
        textStyle="bodySm500"
      >
        {label || ''}
      </Text>
      <Flex height="100%" maxWidth="100%" {...childProps}>
        {children}
      </Flex>
    </Flex>
  );
}

RowGridColumn.propTypes = {
  /** Defines data in column */
  label: PropTypes.string,
  /** Column alignment */
  align: PropTypes.string,
  /** Vertical alignment */
  justify: PropTypes.string,
  /** Children can be single element, string, or number */
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.element, PropTypes.string, PropTypes.number])
};

RowGridColumn.defaultProps = {
  align: 'center',
  justify: 'space-between'
};

export default RowGridColumn;
